import { React, useState, useEffect, useRef } from 'react';
import { FiExternalLink, FiX } from 'react-icons/fi';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { CornerDownRight, CheckSquare, SquareCheck } from 'lucide-react';
import dayjs from 'dayjs';
import { CheckIcon, CloseIcon } from '@chakra-ui/icons';
import Tasksubtasktable from '../Board/Tasksubtasktable';
import { CornerDownLeft } from 'lucide-react';
import { useCallback } from 'react';
import debounce from 'lodash.debounce';

import SkeletonWithLoaders from 'components/common/Spinner';
import LinkWorkItemInput from '../Board/LinkWorkItemInput';
import ListLinkedWorkItems from '../Board/ListLinkedWorkItems';
import WebLink from '../Board/WebLink';
import WebLinkList from '../Board/ListWebLinks';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Box,
  Flex,
  Text,
  Badge,
  VStack,
  HStack,
  Tag,
  Input,
  Avatar,
  Grid,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  IconButton,
  Textarea,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Icon,
  Select,
} from '@chakra-ui/react';
import {
  FaLock,
  FaEye,
  FaShareAlt,
  FaUserCircle,
  FaEdit,
} from 'react-icons/fa';
import { AiOutlineThunderbolt } from 'react-icons/ai';
import { MdOutlinePerson } from 'react-icons/md';
import CreatableSelect from 'react-select/creatable';
import httpInjectorService from 'services/http-injector.service';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { FiMoreHorizontal } from 'react-icons/fi';
import { DeleteIcon } from '@chakra-ui/icons';
import { Tooltip } from '@chakra-ui/react';
import UserAvatar from '../../../../components/userAvatar/index';

import {
  AddIcon,
  ChatIcon,
  RepeatIcon,
  BiReply,
  ChevronDownIcon,
} from '@chakra-ui/icons';
import { Spinner } from 'reactstrap';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';
import TaskmodalActivity from '../Board/TaskmodalActivity';
import {
  ThunderboltOutlined,
  CheckOutlined,
  CloseOutlined,
} from '@ant-design/icons';

import AttachmentList from '../Timeline/attachment/AttachmentList';
import AttachmentMenuItem from '../attachments/AttachmentMenuItem';
import { AttachmentProvider } from '../attachments/AttachmentProvider';
import StoryObject from '@atlaskit/object/story';
import BugObject from '@atlaskit/object/bug';
import TaskObject from '@atlaskit/object/task';

import ShareWorkItemModal from '../share/ShareWorkItemModal';

const TaskModal = ({
  isOpen,
  onClose,
  taskDetails,
  // assigneeList,
  // statusList,
  getTaskBoardDetails,
  handleOpenSubtaskModal,
  Applyfilters,
}) => {
 
  const [showEmployeePicker, setShowEmployeePicker] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [description, setDescription] = useState('');
  const [editingText, setEditingText] = useState('');
  const [reloadSubtasks, setReloadSubtasks] = useState(0);

  const [attachments, setAttachments] = useState([]);

  const [isShareOpen, setIsShareOpen] = useState(false); // share modal state

  const [selectedLabel, setSelectedLabel] = useState([]);
  const [labellist, setLabelList] = useState([]);
  const [taskdata, setTaskData] = useState({});
  const [sprintlist, setSprintlist] = useState({});
  const [selectedSprint, setSelectedSprint] = useState(null);
  const [comments, setComments] = useState([]);
  const [commentInput, setCommentInput] = useState('');
  const [replyInput, setReplyInput] = useState({});
  const [activeReply, setActiveReply] = useState(null);
  const [mentionQuery, setMentionQuery] = useState('');
  const [mentionSuggestions, setMentionSuggestions] = useState([]);
  const [taggedUsers, setTaggedUsers] = useState([]);
  const [newstatus, setnewstatus] = useState('');
  const [showChildInput, setShowChildInput] = useState(false);
  const [childTaskTitle, setChildTaskTitle] = useState('');
  const [childTasks, setChildTasks] = useState([]);
  const [loadingSubtasks, setLoadingSubtasks] = useState(false);
  const [editableTasks, setEditableTasks] = useState({});
  const [subtaskmodal, setSubtaskModal] = useState(false);
  const [selectedSubtask, setSelectedSubtask] = useState(null);
  const [epicModalOpen, setEpicModalOpen] = useState(false);
  const [selectedEpic, setSelectedEpic] = useState('');
  const [epicList, setEpicList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [editedTitle, setEditedTitle] = useState(taskdata?.issue_title || '');
  const [visibleReplies, setVisibleReplies] = useState({});
  const [selectedparent, setSelectedParent] = useState(null);
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [isEditingComment, setIsEditingComment] = useState(false);
  const [activeReplyEditor, setActiveReplyEditor] = useState(null);
  const [panelWidth, setPanelWidth] = useState(400);
  const [rightPaneWidth, setRightPaneWidth] = useState(380);
  const [refreshLinkedItems, setRefreshLinkedItems] = useState(false);
  const [showWebLink, setShowWebLink] = useState(false);
  const [refreshLinks, setRefreshLinks] = useState(false);
  const [openLinkWorkItem, setOpenLinkWorkItem] = useState(false);
  const [localIssueType, setLocalIssueType] = useState(
      taskdata?.issue_type_id || taskDetails.task.issue_type_id
    );
  
    const [issuePopoverOpen, setIssuePopoverOpen] = useState(false); // start width in px
  const panelRef = useRef(null);
  const resizerRef = useRef(null);
  const isResizingRef = useRef(false);

  const statusList = useSelector(
    (status) => status?.Authentication?.taskstatuslist,
  );

  const assigneeList = useSelector(
    (state) => state?.Authentication?.assigneelist,
  );

  const getfilteredrequestbody = useSelector(
    (state) => state?.Authentication?.filteredrequestbody,
  );

  const [innerBoxWidth, setInnerBoxWidth] = useState(400);
  const innerResizingRef = useRef(false);
  const startInnerXRef = useRef(0);
  const startInnerWidthRef = useRef(0);
  const MIN_WIDTH = 250;
  const getMaxWidth = () =>
    Math.min(window.innerWidth * 0.5, window.innerWidth - 250);
  // 50% of screen or leave 250px for left panel

  const [rightWidth, setRightWidth] = useState(() =>
    Math.min(Math.max(window.innerWidth * 0.4, MIN_WIDTH), getMaxWidth()),
  );

  const resizingRef = useRef(false);
  const startXRef = useRef(0);
  const startWidthRef = useRef(0);

  const onMouseDown = (e) => {
    resizingRef.current = true;
    startXRef.current = e.clientX;
    startWidthRef.current = rightWidth;
    document.body.style.userSelect = 'none';

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  const onMouseMove = (e) => {
    if (!resizingRef.current) return;
    const dx = e.clientX - startXRef.current;

    let newW = startWidthRef.current - dx; // drag right -> shrink
    const MAX_WIDTH = getMaxWidth();
    newW = Math.min(Math.max(newW, MIN_WIDTH), MAX_WIDTH);
    setRightWidth(newW);
  };

  const onMouseUp = () => {
    resizingRef.current = false;
    document.body.style.userSelect = '';
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onMouseUp);
  };

  // Update rightWidth dynamically on window resize
  useEffect(() => {
    const handleResize = () => {
      setRightWidth((prev) => Math.min(prev, window.innerWidth * 0.5));
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  //   const innerResizingRef = useRef(false);
  //   const startInnerXRef = useRef(0);
  const startRightWidthRef = useRef(0);

  const onMouseDownInner = (e) => {
    innerResizingRef.current = true;
    startInnerXRef.current = e.clientX;
    startRightWidthRef.current = rightWidth;
    document.addEventListener('mousemove', onMouseMoveInner);
    document.addEventListener('mouseup', onMouseUpInner);
  };

  const onMouseMoveInner = (e) => {
    if (!innerResizingRef.current) return;
    const dx = e.clientX - startInnerXRef.current;

    // ✅ Flip direction: drag right → shrink right box
    const newWidth = Math.min(
      Math.max(startRightWidthRef.current - dx, 250),
      700,
    );
    setRightWidth(newWidth);
  };

  const onMouseUpInner = () => {
    innerResizingRef.current = false;
    document.removeEventListener('mousemove', onMouseMoveInner);
    document.removeEventListener('mouseup', onMouseUpInner);
  };
  // stores comment_id of open reply editor

  const EpicList = useSelector((state) => state?.Authentication?.Epiclist);

  // const [activeReply, setActiveReply] = useState(null);
  const [storyPoints, setStoryPoints] = useState('');

  const roleId = Number(Cookies.get('task-role-id'));

  // To store tagged usernames & ids

  const hasFiltersApplied = (filter) => {
    if (!filter) return false;

    // Only check array fields (ignore project_id)
    const arrayKeys = [
      'sprint_id',
      'epic_id',
      'assignee_id',
      'issue_status',
      'labels_id',
    ];

    return arrayKeys.some((key) => {
      return Array.isArray(filter[key]) && filter[key].length > 0;
    });
  };

  const handleCloseWithSave = () => {
    // if (hasFiltersApplied(getfilteredrequestbody)) {
    //   Applyfilters(getfilteredrequestbody);
    // } else {
    //   getTaskBoardDetails();
    // }

    onClose();
  };

  const handleSaveTitle = () => {
    if (editedTitle.trim() === '') return;
    // --- call your API/update function here ---
    handleTaskUpdate('task_title', editedTitle);
    setIsEditingTitle(false);
  };

  const handleCancel = () => {
    // setEditedTitle(taskdata?.task_title || "");
    setIsEditingTitle(false);
  };

  const formatDateInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; // Still YYYY-MM-DD, but local
  };

  const [dueDate, setDueDate] = useState(formatDateInput(taskdata.due_date));
  const [startDate, setStartDate] = useState(
    formatDateInput(taskdata.start_date),
  );

  const handleDeleteComment = async (commentId) => {
    try {
      const reqBody = {
        project_id: taskdata.project_id,
        comment_id: commentId,
      };

      const res = await httpInjectorService.deletetaskcomment(reqBody);
      if (res.status === 'success') {
        toast.success(res.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        gettaskcomments();
      } else {
        toast.error(res.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error('Error deleting comment:', error);
      toast.error('Something went wrong while deleting comment');
    }
  };

  const handleEditComment = async (commentId, updatedText) => {
    try {
      const reqBody = {
        project_id: taskdata.project_id,
        comment_id: commentId,
        comment_text: updatedText,
      };

      const res = await httpInjectorService.edit_comment(reqBody);
      if (res.status === 'success') {
        toast.success(res.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        gettaskcomments();
      } else {
        toast.error(res.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error('Error updating comment:', error);
      toast.error('Something went wrong while updating comment');
    }
  };

  const ISSUE_TYPES = [
      {
        id: 1,
        label: 'TASK',
        icon: <TaskObject size="small" />,
      },
      {
        id: 2,
        label: 'STORY',
        icon: <StoryObject size="small" />,
      },
      {
        id: 3,
        label: 'BUG',
        icon: <BugObject size="small" />,
      },
    ];
  
    const selectedIssue =
      ISSUE_TYPES.find((i) => i.id === localIssueType) ||
      ISSUE_TYPES[0];

   const handleOpenLinkWorkItem = () => {
    setOpenLinkWorkItem(true);
  };

  const toggleReplies = (commentId, totalReplies) => {
    setVisibleReplies((prev) => ({
      ...prev,
      [commentId]:
        prev[commentId] && prev[commentId] < totalReplies
          ? totalReplies // show all
          : 2, // collapse back to 2
    }));
  };

  useEffect(() => {
    if (taskdata?.labels) {
      const formatted = taskdata.labels.map((label) => ({
        label: label.label_name,
        value: label.label_id,
        __isNew__: false,
      }));
      setSelectedLabel(formatted);
    }
  }, [taskdata]);

  const handleAddLabel = async (updatedLabels = selectedLabel) => {
    try {
      // Always use the latest labels passed from onChange
      if (!updatedLabels || updatedLabels.length === 0) {
      }

      const newLabels = updatedLabels.filter((label) => label.__isNew__);
      const existingLabels = updatedLabels.filter((label) => !label.__isNew__);

      const newLabelNames = newLabels.map((label) => label.label);
      const existingLabelIds = existingLabels.map((label) => label.value);

      const requestBody = {
        project_id: taskDetails.project_id,
        issue_id: taskDetails.issue_id,
        issue_type_id: taskDetails.issue_type_id,
        sprint_id: taskDetails.task.sprint_id,
      };

      // Attach ONLY if present
      if (newLabelNames.length > 0) {
        requestBody.new_label_name = newLabelNames;
      }

      // ❗Attach only CURRENT selected IDs, NOT old
      requestBody.labels_id = existingLabelIds; // even if empty []

      const response = await httpInjectorService.createLabel(requestBody);

      if (response.status !== 'success') {
        // error toast if needed
      }
    } catch (error) {
      console.error(error);
      toast.error('Something went wrong while adding labels', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  const getLabelList = async () => {
    try {
      const response = await httpInjectorService.getlabelList(
        taskDetails.project_id,
      );
      if (response.status === 'success') {
        setLabelList(response.data);
      } else {
        setLabelList([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const gettaskdata = async () => {
    let reqbody = {
      project_id: taskDetails.project_id,
      issue_id: taskDetails?.task?.issue_id || taskDetails?.issue_id,
      issue_type_id:
        taskDetails?.task?.issue_type_id || taskDetails?.issue_type_id,
    };
    try {
      const response = await httpInjectorService.gettaskdata(reqbody);

      if (response.status === 'success') {
        setTaskData(response.data);
      } else {
        setTaskData({});
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleEditChange = (subtaskId, field, value) => {
    setEditableTasks((prev) => ({
      ...prev,
      [subtaskId]: {
        ...prev[subtaskId],
        [field]: value,
      },
    }));
  };

  const triggerRefresh = () => {
    setRefreshLinkedItems((prev) => !prev);
  };

  const handleopensubtaskmodal = (task) => {
    setSelectedSubtask(task);
    setSubtaskModal(true);
  };

  const saveSubtask = async (subtaskId) => {
    const edited = editableTasks[subtaskId] || {};
    const original = childTasks.find((t) => t.subtask_id === subtaskId);

    if (!original) {
      console.error('Original task not found');
      return;
    }

    const reqBody = {
      project_id: taskdata.project_id, // or dynamic
      subtask_id: subtaskId,
      title: edited.title !== undefined ? edited.title : original.subtask_title,
      subtask_status:
        edited.status !== undefined ? edited.status : original.status,
      subtask_priority:
        edited.priority !== undefined
          ? edited.priority
          : original.priority || 'Medium',
      subtask_assignee_id:
        edited.assignee_id !== undefined
          ? edited.assignee_id
          : original.assignee_id || null,
    };

    try {
      const response = await httpInjectorService.updateSubtask(reqBody);
      if (response.status === 'success') {
        // Optionally refresh or give feedback
      }
    } catch (error) {
      console.error('Error saving subtask:', error);
    }
  };

  useEffect(() => {
    gettaskcomments();
    getEpiclist();
  }, []);

  const deleteChildTask = async (subtaskId) => {
    try {
      let reqbody = {
        project_id: taskdata.project_id,
        subtask_ids: [subtaskId],
      };
      let response = await httpInjectorService.delete_subtask(reqbody);
      if (response.status === 'success') {
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        setChildTasks((prev) =>
          prev.filter((task) => task.subtask_id !== subtaskId),
        );
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error('Error deleting child task:', error);
    }
  };

  const gettaskcomments = async () => {
    let reqbody = {
      project_id: taskDetails.project_id,
      task_id: taskDetails.task_id,
    };
    try {
      const res = await httpInjectorService.gettaskcomments(reqbody);
      if (res.status === 'success') {
        setComments(res.data);
      } else {
        console.error('Failed to fetch comments:', res.message);
      }
    } catch (err) {
      console.error('Error fetching comments:', err);
    }
  };

  const handleSaveLink = (data) => {
  
    setRefreshLinks((prev) => !prev);
    // you can store it, send API, etc
    setShowWebLink(false);
  };

  const handleMentionSelect = (user) => {
    const words = commentInput.trim().split(/\s+/);
    words.pop(); // remove @something
    words.push(`@${user.username}`);
    const newText = words.join(' ') + ' ';
    setCommentInput(newText);
    setTaggedUsers((prev) => [...prev, user]); // Store tagged user info
    setMentionSuggestions([]);
    setMentionQuery('');
  };

  const postComment = async (text, parentId = null) => {
    if (!text.trim()) return;

    const taggedUserIds = [
      ...new Set(
        taggedUsers
          .filter((user) => text.includes(`@${user.username}`))
          .map((user) => user.user_id),
      ),
    ];

    const requestBody = {
      project_id: taskdata.project_id,
      issue_id: taskdata.issue_id,
      comment_text: text,
      tagged_user_ids: taggedUserIds,
    };

    if (parentId) {
      requestBody.parent_comment_id = parentId;
    }

    try {
      const response = await httpInjectorService.addComments(requestBody);

      if (response.status === 'success') {
        // Clear input(s)
        if (parentId) {
          setReplyInput((prev) => ({ ...prev, [parentId]: '' }));
          setActiveReply(null);
        } else {
          setCommentInput('');
        }

        setTaggedUsers([]);
        gettaskcomments();
      } else {
        console.error('Failed to post comment:', response.message || response);
      }
    } catch (err) {
      console.error('Error posting comment:', err);
    }
  };

  useEffect(() => {
    if (taskdata?.epic_id) {
      const found = EpicList?.find((epic) => epic.epic_id === taskdata.epic_id);
      if (found) {
        setSelectedParent({ value: found.epic_id, label: found.epic_name });
      }
    }
  }, [taskdata, EpicList]);

  const getsprintlist = async () => {
    try {
      let response = await httpInjectorService.getsprintList(
        taskDetails.project_id,
      );

      if (response.status === 'success') {
        const activeSprints = response.data?.active_sprints || [];

        // Convert to options format for CreatableSelect
        const options = activeSprints?.map((sprint) => ({
          label: sprint.sprint_name,
          value: sprint.sprint_id,
        }));

        setSprintlist(options);

        // Preselect based on taskDetails
        const currentSprintName = taskdata?.sprint_name || ' ';
        const matchedSprint = options?.find(
          (opt) => opt.label === currentSprintName,
        );

        if (matchedSprint) {
          setSelectedSprint(matchedSprint);
        }
      } else {
        setSprintlist([]);
      }
    } catch (error) {
      console.error('Error fetching sprint list:', error);
      setSprintlist([]);
    }
  };

  useEffect(() => {
    if (isOpen && (taskDetails?.issue_id || taskDetails?.task?.issue_id)) {
      const id = taskDetails?.issue_id || taskDetails?.task?.issue_id;
      gettaskdata(id);
    }
    getsprintlist();
    getLabelList();
    getEpiclist();
  }, [isOpen, taskDetails]);

  useEffect(() => {
    if (isOpen && taskdata) {
      setDescription(taskdata?.description);
      setDueDate(formatDateInput(taskdata?.due_date) || '');
      setStartDate(formatDateInput(taskdata?.start_date) || '');
      setStoryPoints(taskdata?.story_points ?? '');
      if (taskdata?.epic_id && taskdata?.epic_name) {
        setSelectedParent({
          value: taskdata.epic_id,
          label: taskdata.epic_name,
        });
      } else {
        setSelectedParent(null);
      }
    }
  }, [isOpen, taskdata]);

  const sprintOptions = Array.isArray(sprintlist)
    ? sprintlist
    : sprintlist?.data || [];

  const handleTaskUpdate = async (emp = {}) => {
    const finalBody = {
      issue_id: taskdata.task?.task_id || taskdata.issue_id,
      issue_type_id: taskdata.task?.issue_type_id || taskdata.issue_type_id,
      project_id: taskdata.project_id,
      issue_title: editedTitle || taskdata?.issue_title,
      // epic_id: selectedEpic || selectedparent?.value || taskdata.epic_id,
      sprint_id: selectedSprint?.value || taskdata.sprint_id || null,
      epic_id: emp?.value || taskdata.epic_id || null,
      story_points: storyPoints || taskdata.story_points || null,
      assignee_id: emp?.user_id || taskdata.assignee_id || null,
      description: description?.trim() || taskdata.description || '',
      issue_status: emp?.status_name || taskdata.issue_status,
      issue_priority: taskdata.issue_priority,
      start_date: startDate || taskdata.start_date,
      due_date: dueDate || taskdata.due_date,
      work_item_url: `${window.location.origin}/admin/taskBoard/${taskdata?.project_id}/taskDetails/${taskdata.task?.task_id || taskdata.issue_id}`,
    };

    try {
      const response = await httpInjectorService.Taskedit(finalBody);
      if (response?.status === 'success') {
        gettaskdata();
        if (hasFiltersApplied(getfilteredrequestbody)) {
          Applyfilters(getfilteredrequestbody);
        } else {
          getTaskBoardDetails();
        }
      }
    } catch (error) {
      console.error('Error updating task:', error);
      toast.error('Something went wrong.');
    }
  };
  const debouncedUpdate = useCallback(
    debounce(() => handleTaskUpdate(), 400),
    [handleTaskUpdate],
  );

  const handleCommentChange = (value) => {
    setCommentInput(value);

    // Find the last "@mention" pattern anywhere in the text
    const match = value.match(/@(\w*)$/);

    if (match) {
      const query = match[1].toLowerCase();
      const suggestions = assigneeList.filter((user) =>
        user.username.toLowerCase().includes(query),
      );
      setMentionQuery(query);
      setMentionSuggestions(suggestions);
    } else {
      setMentionQuery('');
      setMentionSuggestions([]);
    }
  };

  const justOpenedRef = useRef(true);

  const getEpiclist = async () => {
    const queryParams = `?project_id=${taskDetails.project_id}`;
    try {
      const response = await httpInjectorService.get_epic(queryParams);

      setEpicList(response.data);
    } catch (error) {
      console.error('Failed to fetch epics:', error);
    }
  };

  useEffect(() => {
    if (epicModalOpen) {
      getEpiclist(); // fetch only when modal is opened
    }
  }, [epicModalOpen]);

  const getsubtaskList = async () => {
    setLoadingSubtasks(true);
    let reqbody = {
      project_id: taskDetails.project_id,
      issue_id: taskDetails?.issue_id,
    };
    try {
      const response = await httpInjectorService.getsubtaskList(reqbody);
      setChildTasks(response.data);
      // assuming array of { id, title }
    } catch (error) {
      console.error('Error fetching subtasks:', error);
    } finally {
      setLoadingSubtasks(false);
    }
  };

  const isEditable = [1, 2, 3].includes(roleId);

  useEffect(() => {
    getsubtaskList();
  }, [taskdata?.issue_id]);

  const handleAddSubtask = async () => {
    let reqbody = {
      project_id: taskdata.project_id,
      issue_id: taskdata.issue_id,
      issue_type_id: taskdata.issue_type_id,
      issue_type: taskdata.issue_type,
      title: childTaskTitle || '',
      description: null,
      subtask_status: 'TO DO',
      subtask_priority: 'Medium',
      start_date: null,
      due_date: null,
      labels_id: null,
      subtask_assignee_id: null,
    };

    try {
      const response = await httpInjectorService.addSubtask(reqbody);
      if (response.status === 'success') {
        setChildTaskTitle('');
        setShowChildInput(false);
        setReloadSubtasks((prev) => prev + 1);
        getsubtaskList(); // Refresh list
      } else {
        console.error('Failed to add subtask');
      }
    } catch (error) {
      console.error('Error adding subtask:', error);
    }
  };

  const handlesubtaskmodal = () => {
    setSubtaskModal(false);
  };

  const getStatusColors = (status = '') => {
    const s = status.toUpperCase(); // normalize

    switch (s) {
      case 'DONE':
        return { bg: 'green.300', color: 'black' };

      case 'TO DO':
        return { bg: 'gray.300', color: 'black' };

      default:
        return { bg: 'blue.300', color: 'black' };
    }
  };

  const currentStatus = newstatus || taskdata.issue_status;
  const { bg, color } = getStatusColors(currentStatus);
  // const updatesubtask=async()=>{

  //   let reqbody={
  //     project_id:5,
  // subtask_id: 11,
  // title: "subtask edit test_12",
  // subtask_status: "Blocked",
  // subtask_priority: "Medium",
  // subtask_assignee_id: 157
  //   }
  //   try{
  //     let response=await httpInjectorService.updateSubtask(reqbody)
  //     if(response.status==="success"){

  //     }
  //   }catch(error){

  //   }
  // }

  useEffect(() => {
    if (isOpen) {
      justOpenedRef.current = true;
    }
  }, [isOpen]);

  const handleStatusChange = (status) => {
    setnewstatus(status);
  };

  const formatAssigneeLabel = (username) => {
    if (!username) return 'Unassigned';

    const nameParts = username.trim().split(' ');
    const initials = nameParts
      .map((n) => n[0])
      .join('')
      .toUpperCase();

    return `${initials} - ${username}`;
  };

  const fetchAttachments = async () => {
    try {
      if (!taskdata?.project_id || !taskdata?.task_id) {
        setAttachments([]);
        return;
      }
      const payload = {
        project_id: taskdata.project_id,
        epic_id: taskdata?.epic_id || null,
        epic_key: taskdata?.epic_key || null,
        issue_id: taskdata?.issue_id || null,
        issue_key:
          taskDetails?.task?.issue_key || taskDetails?.issue_key || null,
      };

     

      // Call as POST to ensure payload is sent in body
      const res = await httpInjectorService.getAttachment(payload);

      if (res.status === 'success' && res.data) {
        setAttachments(Array.isArray(res.data) ? res.data : []);
      } else {
        setAttachments([]);
      }
    } catch (error) {
      console.error('Error fetching attachments:', error);
      setAttachments([]);
    }
  };

  // delete attachment
  const handleDeleteAttachment = async (id) => {
    setAttachments((prev) => prev.filter((att) => att.attachment_id !== id));

    // Optional backend api call
    await httpInjectorService.deleteAttachment({
      attachment_id: id,
      project_id: taskdata.project_id,
    });

    toast.success('Attachment removed', {
      position: 'top-right',
      autoClose: 3000,
    });
  };

  // Sync taskDetails → taskdata
  useEffect(() => {
    if (taskDetails) {
      setTaskData(taskDetails.task || taskDetails);
    }
  }, [taskDetails]);

  useEffect(() => {
    if (isOpen && taskdata?.project_id && taskdata?.issue_id) {
      fetchAttachments();
    }
  }, [isOpen, taskdata?.project_id, taskdata?.issue_id]);

  useEffect(() => {
    if (isOpen && (taskDetails?.issue_id || taskDetails?.task?.issue_id)) {
      setLoading(true);

      const fetchAllData = async () => {
        try {
          await Promise.all([
            gettaskdata(),
            getsprintlist(),
            getLabelList(),
            gettaskcomments(),
            getsubtaskList(),
          ]);
        } catch (error) {
          console.error('Error loading modal data:', error);
        } finally {
          setLoading(false); // ✅ hide spinner after all API calls finish
        }
      };

      fetchAllData();
    }
  }, [isOpen, taskDetails]);

  const ISSUE_TYPE_ICON_MAP = {
    1: TaskObject, // TASK
    2: StoryObject, // STORY
    3: BugObject, // BUG
  };

  const IssueIcon =
    ISSUE_TYPE_ICON_MAP[
      taskDetails.issue_type_id || taskDetails.task.issue_type_id
    ];

  return (
    <div>
      <Modal
        isOpen={isOpen}
        onClose={handleCloseWithSave}
        size="7xl"
        isCentered
        scrollBehavior="inside"
      >
        <ModalOverlay />

        <ModalContent maxW="95vw" w="90vw" maxH="90vh">
          <ModalHeader>
            <Flex justify="space-between" align="center">
               <HStack spacing={1} align="center">
                             {/* Epic */}
                             <HStack spacing={1} align="center">
                               <ThunderboltOutlined
                                 style={{
                                   color: '#884B9E',
                                   fontSize: '18px',
                                 }}
                               />
             
                               <Text fontSize="md" color="gray.600" mt="12px">
                                 {selectedEpic || taskdata?.epic_key
                        ? epicList?.find(
                            (epic) =>
                              epic.epic_id ===
                              (selectedEpic || taskdata?.epic_key),
                          )?.epic_key || taskdata?.epic_key
                        : [1, 2, 3].includes(roleId) && (
                            <Button
                              onClick={() => setEpicModalOpen(true)}
                              variant="ghost"
                              size="md"
                              p={0}
                              fontSize="18px"
                              minW="auto"
                              height="auto"
                              color="gray.500"
                              _hover={{ bg: 'transparent', color: 'gray.600' }}
                              leftIcon={<FaEdit size="14px" />}
                            >
                              Add epic
                            </Button>
                          )}
                               </Text>
             
                               <Text fontSize="md" color="gray.600" mt="12px">
                                 /
                               </Text>
                             </HStack>
             
                             {/* Issue Type */}
                             <Popover
                               isOpen={issuePopoverOpen}
                               onClose={() => setIssuePopoverOpen(false)}
                               placement="bottom-start"
                             >
                               <PopoverTrigger>
                                 <div
                                   onClick={(e) => {
                                     e.stopPropagation();
                                     setIssuePopoverOpen(!issuePopoverOpen);
                                   }}
                                   style={{
                                     cursor: 'pointer',
                                     display: 'flex',
                                     alignItems: 'center',
                                     gap: 6,
                                   }}
                                 >
                                   {selectedIssue.icon}
             
                                   <Text fontSize="md" color="gray.600" m={0}>
                                     {taskdata?.issue_key || taskDetails?.task?.issue_key}
                                   </Text>
                                 </div>
                               </PopoverTrigger>
             
                               <PopoverContent width="140px">
                                 <PopoverBody p={1}>
                                   {ISSUE_TYPES.map((item) => (
                                     <div
                                       key={item.id}
                                       onClick={() => {
                                         setLocalIssueType(item.id);
             
                                         handleTaskUpdate({
                                           issue_type_id: item.id,
                                         });
             
                                         setIssuePopoverOpen(false);
                                       }}
                                       style={{
                                         display: 'flex',
                                         alignItems: 'center',
                                         gap: 8,
                                         padding: '6px 8px',
                                         borderRadius: 6,
                                         cursor: 'pointer',
                                         fontSize: '13px', // <- add this
                                       }}
                                     >
                                       {item.icon}
             
                                       <span style={{ fontSize: '13px' }}>
                                         {item.label}
                                       </span>
                                     </div>
                                   ))}
                                 </PopoverBody>
                               </PopoverContent>
                             </Popover>
                           </HStack>

              <HStack spacing={2}>
                <IconButton
                  icon={<FaLock />}
                  size="lg"
                  variant="ghost"
                  aria-label="lock"
                />
                <IconButton
                  icon={<FaEye />}
                  size="lg"
                  variant="ghost"
                  aria-label="view"
                />
                <IconButton
                  icon={<FaShareAlt />}
                  size="lg"
                  variant="ghost"
                  aria-label="share"
                  onClick={() => setIsShareOpen(true)}
                />
                <Flex align="center" gap={4}>
                  {/* Open in new tab icon */}
                  {/* <Box
                    as="button"
                    onClick={() => {
                      const url = `/admin/taskBoard/${taskDetails?.project_id}/taskDetails/${taskdata?.task_id}`;
                      window.open(url, '_blank');
                    }}
                    cursor="pointer"
                    _hover={{ color: 'blue.500' }}
                    bg="transparent"
                    border="none"
                  >
                    <Icon as={FiExternalLink} boxSize={5} color="gray.700" />
                  </Box> */}
                  <a
                    href={`/admin/taskBoard/${taskDetails?.project_id}/taskDetails/${taskdata?.issue_id}`}
                    rel="noopener noreferrer"
                    target="_blank"
                    style={{
                      background: 'transparent',
                      border: 'none',
                      cursor: 'pointer',
                      display: 'inline-flex',
                      alignItems: 'center',
                    }}
                  >
                    <Icon as={FiExternalLink} boxSize={5} color="gray.700" />
                  </a>
                </Flex>
                <IconButton
                  icon={<AiOutlineThunderbolt />}
                  size="sm"
                  variant="ghost"
                  aria-label="action"
                />
                <ModalCloseButton position="static" />
              </HStack>
            </Flex>
          </ModalHeader>

          <ModalBody
            p={0}
            style={{
              overflowY: 'hidden', // vertical scrolling
              // prevent horizontal scroll
              // smooth height change
            }}
          >
            {loading ? (
              <Flex justify="center" align="center" w="100%" h="300px">
                <SkeletonWithLoaders />
              </Flex>
            ) : (
              <Flex direction="row" h="100%" maxH="85vh">
                <Box
                  flex="1"
                  p={6}
                  overflowY="auto"
                  bg="white"
                  style={{
                    height: 'calc(100vh - 210px)', // adjust top/bottom offset as needed
                    display: 'flex',
                    flexDirection: 'column',
                    overflowY: 'auto', // vertical scrolling
                    // prevent horizontal scroll
                    transition: 'height 0.2s ease', // smooth height change
                  }}
                >
                  <Box mb={4}>
                    {!isEditingTitle ? (
                      // --- Normal Text ---
                      <Text
                        fontSize="2xl"
                        fontWeight="bold"
                        cursor="pointer"
                        onClick={() => {
                          if ([1, 2, 3].includes(roleId)) {
                            setEditedTitle(taskdata?.issue_title);
                            setIsEditingTitle(true);
                          }
                        }}
                      >
                        {editedTitle || taskdata?.issue_title || 'Task Title'}
                      </Text>
                    ) : (
                      // --- Editing Mode ---
                      <Box position="relative" width="100%">
                        <Input
                          value={editedTitle}
                          onChange={(e) => setEditedTitle(e.target.value)}
                          size="lg"
                          fontSize="2xl"
                          fontWeight="bold"
                          autoFocus
                          height="40px"
                          focusBorderColor="gray.300"
                          borderRadius="md"
                        />

                        {/* Wrapper ABSOLUTE but not blocking input */}
                        <HStack
                          spacing={2}
                          position="absolute"
                          right="0"
                          top="100%"
                          mt={1}
                          pointerEvents="none"
                        >
                          <Box
                            p={1}
                            border="1px solid #d1d5db"
                            borderRadius="sm"
                            cursor="pointer"
                            pointerEvents="auto"
                            onClick={() => {
                              handleTaskUpdate(); // call the update function
                              setIsEditingTitle(false); // exit edit mode
                            }}
                          >
                            <CheckIcon boxSize={4} color="grey" />
                          </Box>

                          <Box
                            p={1}
                            border="1px solid #d1d5db"
                            borderRadius="sm"
                            cursor="pointer"
                            pointerEvents="auto"
                            onClick={handleCancel}
                          >
                            <CloseIcon boxSize={4} color="grey" />
                          </Box>
                        </HStack>
                      </Box>
                    )}

                    {[1, 2, 3].includes(roleId) && (
                      <AttachmentProvider
                        context={{
                          project_id:
                            taskdata.project_id || taskDetails?.project_id,
                          epic_id: taskdata?.epic_id || null,
                          epic_key: taskdata?.epic_key || null,
                          issue_id: taskdata?.issue_id || null,
                          issue_key:
                            taskDetails?.task?.issue_key ||
                            taskDetails?.issue_key ||
                            null,
                        }}
                        onUploaded={fetchAttachments}
                      >
                        <Menu>
                          <MenuButton
                            as={IconButton}
                            icon={<AddIcon />}
                            size="sm"
                            aria-label="Add actions"
                            bg="#f3f4f6"
                            border="1px solid #d1d5db"
                            borderRadius="md"
                            _hover={{ bg: '#e5e7eb' }}
                            _active={{ bg: '#e5e7eb' }}
                            color="gray.700"
                            mt={1}
                            mb={30}
                            position="relative"
                            zIndex={1}
                          />

                          <MenuList zIndex={1}>
                            <MenuItem onClick={() => setShowChildInput(true)}>
                              Create child work item
                            </MenuItem>
                            <MenuItem
                              onClick={handleOpenLinkWorkItem}
                            >
                              Link work Items
                            </MenuItem>

                            <AttachmentMenuItem />

                            <MenuItem
                              onClick={() => {
                                console.log('clicked');
                                setShowWebLink(true);
                              }}
                            >
                              Add web link
                            </MenuItem>
                            <MenuItem
                              onClick={() => console.log('Assign task clicked')}
                            >
                              Page
                            </MenuItem>
                            <MenuItem
                              onClick={() =>
                                console.log('Add attachment clicked')
                              }
                            >
                              Whiteboard
                            </MenuItem>
                          </MenuList>
                        </Menu>
                      </AttachmentProvider>
                    )}
                  </Box>

                  <Box mb={6} mt={2}>
                    <Text fontWeight="semibold" mb={2}>
                      Description
                    </Text>

                    {!isEditingDescription ? (
                      <Box
                        p={3}
                        border="1px solid #e2e8f0"
                        // borderRadius="8px"
                        minH="60px"
                        bg="white"
                        onClick={() =>
                          [1, 2, 3].includes(roleId) &&
                          setIsEditingDescription(true)
                        }
                        cursor={
                          ![1, 2, 3].includes(roleId) ? 'not-allowed' : 'text'
                        }
                      >
                        {description ? (
                          <Box
                            dangerouslySetInnerHTML={{ __html: description }}
                            fontSize="sm"
                          />
                        ) : (
                          <Text color="gray.400" fontSize="sm">
                            Add a description...
                          </Text>
                        )}
                      </Box>
                    ) : (
                      <Box>
                        <ReactQuill
                          theme="snow"
                          value={description}
                          onChange={setDescription}
                          placeholder="Write a description..."
                          onBlur={() => {
                            // ✅ Auto-save when editor loses focus
                            handleTaskUpdate('description', description);
                          }}
                          modules={{
                            toolbar: [
                              ['bold', 'italic', 'underline', 'strike'],
                              [{ list: 'ordered' }, { list: 'bullet' }],
                              [{ color: [] }, { background: [] }],
                              ['link', 'image', 'code-block'],
                              ['clean'],
                            ],
                          }}
                          style={{
                            backgroundColor: 'white',
                            // borderRadius: '8px',
                            minHeight: '140px',
                          }}
                        />
                        <Flex justify="flex-start" mt={1} gap={2}>
                          <Button
                            size="sm"
                            colorScheme="blue"
                            borderRadius="0px"
                            onClick={() => {
                              setIsEditingDescription(false);
                              handleTaskUpdate('description', description); // ✅ Save on Done click
                            }}
                          >
                            Save
                          </Button>
                          <Button
                            size="sm"
                            variant="ghost"
                            borderRadius="0px"
                            onClick={() => setIsEditingDescription(false)}
                          >
                            cancel
                          </Button>
                        </Flex>
                      </Box>
                    )}
                  </Box>
                    {openLinkWorkItem && (
                    <div style={{ marginTop: '16px' }}>
                      <LinkWorkItemInput
                        onCancel={() => setOpenLinkWorkItem(false)}
                        current_item_type={'issue'}
                        current_item_id={taskdata.issue_id}
                        onSuccess={triggerRefresh}
                      />
                    </div>
                  )}
                  {showWebLink && (
                    <WebLink
                      onClose={() => setShowWebLink(false)}
                      onSave={handleSaveLink}
                      work_id={taskdata.issue_id}
                      work_type={'issue'}
                    />
                  )}

                  
                  {/* Attachment upload UI */}
                  <Box mb={6}>
                    {attachments?.length > 0 && (
                      <AttachmentList
                        onDelete={handleDeleteAttachment}
                        attachments={attachments}
                      />
                    )}
                  </Box>

                  <Tabs variant="unstyled">
                    {/* Tabs */}
                    <TabList gap={2}>
                      <Tab
                        fontSize="12px"
                        px="8px"
                        py="3px"
                        _selected={{
                          border: '1px solid #3182CE',
                          color: '#3182CE',
                          bg: 'white',
                          borderRadius: '4px',
                        }}
                      >
                        Subtasks
                      </Tab>

                      <Tab
                        fontSize="12px"
                        px="8px"
                        py="3px"
                        _selected={{
                          border: '1px solid #3182CE',
                          color: '#3182CE',
                          bg: 'white',
                          borderRadius: '4px',
                        }}
                      >
                        Linked Items
                      </Tab>
                    </TabList>

                    {/* Tab Content */}
                    <TabPanels mt={4}>
                      {/* Subtasks */}
                      <TabPanel p={0}>
                        <Tasksubtasktable
                          assigneeList={assigneeList}
                          statusList={statusList}
                          taskdata={taskdata}
                          taskDetails={taskDetails}
                          reload={reloadSubtasks}
                          opensubtaskmodal={handleOpenSubtaskModal}
                        />
                      </TabPanel>

                      {/* Linked Items */}
                      <TabPanel p={0}>
                        <ListLinkedWorkItems
                          item_id={taskdata.issue_id}
                          item_type={'issue'}
                          refreshFlag={refreshLinkedItems}
                        />
                      </TabPanel>
                    </TabPanels>
                  </Tabs>

                  {showChildInput && (
                    <HStack mb={4} mt={3}>
                      <Text fontWeight="semibold" mb={2}>
                        Subtask
                      </Text>
                      <Input
                        placeholder="What needs to be done?"
                        size="md"
                        borderRadius="0px"
                        value={childTaskTitle}
                        onChange={(e) => setChildTaskTitle(e.target.value)}
                        onKeyDown={(e) =>
                          e.key === 'Enter' && handleAddSubtask()
                        }
                      />
                      <Button
                        size="sm"
                        colorScheme="blue"
                        borderRadius="0px"
                        onClick={handleAddSubtask}
                      >
                        <CornerDownLeft />
                      </Button>
                      <Button
                        size="sm"
                        borderRadius="0px"
                        onClick={() => setShowChildInput(false)}
                      >
                        Cancel
                      </Button>
                    </HStack>
                  )}
                  <WebLinkList
                    work_id={taskdata.issue_id}
                    work_type={'issue'}
                    refreshFlag={refreshLinks}
                  />


                  {/* Comment Input */}
                

                  <Box>
                    <TaskmodalActivity
                      taskDetails={taskDetails}
                      taskdata={taskdata}
                      taskID={taskdata.issue_id}
                      taskIssueTypeId={taskdata.issue_type_id}
                      projectId={taskdata.project_id}
                    />
                  </Box>
                </Box>

                <Box
                  width="6px"
                  cursor="ew-resize"
                  bg="gray.200"
                  _hover={{ bg: 'gray.400' }}
                  onMouseDown={onMouseDown}
                />
                <Box
                  flex="none"
                  width={`${rightWidth}px`}
                  p={6}
                  pr={0}
                  right={0}
                  borderLeft="1px solid #e2e8f0"
                  // bg="gray.50"
                  overflowY="auto"
                  style={{
                    height: 'calc(100vh - 210px)', // adjust top/bottom offset as needed
                    // display: 'flex',
                    flexDirection: 'column',
                    overflowY: 'auto', // vertical scrolling
                    // prevent horizontal scroll
                    transition: 'height 0.2s ease', // smooth height change
                  }}
                >
                  <Tooltip
                    label={!isEditable ? 'You do not have permission' : ''}
                  >
                    <Menu isDisabled={!isEditable}>
                      <MenuButton
                        as={Button}
                        rightIcon={<ChevronDownIcon />}
                        size="sm"
                        mb={4}
                        p={0}
                        px={0}
                        minW="fit-content"
                        width="fit-content"
                        height="auto"
                        borderRadius="md"
                        bg={bg} // status background
                        color={color} // text color
                        border="1px solid #ccc"
                        _hover={{ bg }}
                        _active={{ bg }}
                      >
                        <Badge
                          bg="transparent"
                          color={color}
                          fontSize="0.8em"
                          p={1}
                        >
                          {currentStatus}
                        </Badge>
                      </MenuButton>

                      {isEditable && (
                        <MenuList>
                          {statusList?.map((status) => {
                            const { bg, color } = getStatusColors(
                              status.status_name,
                            );
                            return (
                              <MenuItem
                                key={status.id}
                                onClick={() => {
                                  handleStatusChange(status.status_name);
                                  handleTaskUpdate(status);
                                }}
                              >
                                <Badge
                                  bg={bg}
                                  color={color}
                                  fontSize="0.75em"
                                  p={1}
                                  borderRadius="md"
                                >
                                  {status.status_name}
                                </Badge>
                              </MenuItem>
                            );
                          })}
                        </MenuList>
                      )}
                    </Menu>
                  </Tooltip>

                  <Grid
                    templateColumns="120px 1fr"
                    rowGap={5}
                    columnGap={6}
                    alignItems="start"
                  >
                    <Text fontWeight="semibold">Assignee</Text>
                    <Tooltip
                      label={!isEditable ? 'You do not have permission' : ''}
                    >
                      <Popover
                        isOpen={showEmployeePicker}
                        onClose={() => setShowEmployeePicker(false)}
                      >
                        <Box position="relative" width="fit-content">
                          <PopoverTrigger>
                            <HStack
                              spacing={2}
                              onClick={() =>
                                setShowEmployeePicker(!showEmployeePicker)
                              }
                              cursor="pointer"
                            >
                              {selectedEmployee?.username ||
                              taskdata?.assignee_name ? (
                                <>
                                  <UserAvatar
                                    username={
                                      selectedEmployee?.username ||
                                      taskdata?.assignee_name
                                    }
                                    size={24}
                                  />
                                  <Text fontSize="sm">
                                    {selectedEmployee?.username ||
                                      taskdata?.assignee_name}
                                  </Text>
                                </>
                              ) : (
                                <HStack spacing={1} color="gray.500">
                                  <MdOutlinePerson size={20} />
                                  <Text fontSize="sm">Unassigned</Text>
                                </HStack>
                              )}
                            </HStack>
                          </PopoverTrigger>
                        </Box>
                        {isEditable && (
                          <PopoverContent width="auto">
                            <PopoverBody>
                              {assigneeList?.length > 0 ? (
                                <Box maxH="200px" overflowY="auto">
                                  {assigneeList?.map((emp) => (
                                    <Box
                                      key={emp.user_id}
                                      onClick={() => {
                                        setSelectedEmployee(emp);
                                        setShowEmployeePicker(false);
                                        handleTaskUpdate(emp);
                                      }}
                                      display="flex"
                                      alignItems="center"
                                      px={2}
                                      py={1}
                                      borderRadius="md"
                                      cursor="pointer"
                                      bg={
                                        selectedEmployee?.user_id ===
                                        emp.user_id
                                          ? '#e6f4ff'
                                          : 'transparent'
                                      }
                                      _hover={{ bg: '#f1f5f9' }}
                                    >
                                      <UserAvatar
                                        username={emp.username}
                                        size={24}
                                        style={{ marginRight: '8px' }}
                                      />
                                      <Text fontSize="sm">{emp.username}</Text>
                                    </Box>
                                  ))}
                                </Box>
                              ) : (
                                <Text fontSize="sm" color="gray.500">
                                  No employees found
                                </Text>
                              )}
                            </PopoverBody>
                          </PopoverContent>
                        )}
                      </Popover>
                    </Tooltip>

                    <Text fontWeight="semibold">Labels</Text>
                    {/* <Box w="100%">
                    <CreatableSelect
                      placeholder="Select or create label"
                      isClearable
                      isMulti
                      value={selectedLabel}
                      options={labellist.map((label) => ({
                        label: label.label_name,
                        value: label.label_id,
                      }))}
                      onChange={(newValue) => setSelectedLabel(newValue || [])}
                      formatCreateLabel={(inputValue) =>
                        `Create new label: "${inputValue}"`
                      }
                    />
                  </Box> */}
                    <Box w="100%">
                      {/* <CreatableSelect
                                    placeholder="Select or create label"
                                    isClearable
                                    isMulti
                                    value={
                          selectedLabel.length > 0
                            ? selectedLabel
                            : (taskdata?.labels || []).map((label) => ({
                                label: label.label_name || label,
                                value: label.label_id || label,
                              }))
                        }
                                    options={labellist.map((label) => ({
                                      label: label.label_name,
                                      value: label.label_id,
                                      __isNew__: false,
                                    }))}
                                    onChange={(newValue) => {
                                      setSelectedLabel(newValue || []);
                                    }}
                                    formatCreateLabel={(inputValue) =>
                                      `Create new label: "${inputValue}"`
                                    }
                                  /> */}

                      <CreatableSelect
                        isDisabled={![1, 2, 3].includes(roleId)}
                        isClearable
                        isMulti
                        placeholder="Select or create label"
                        value={selectedLabel} // ✔ ONLY this
                        options={labellist?.map((label) => ({
                          label: label.label_name,
                          value: label.label_id,
                          __isNew__: false,
                        }))}
                        onChange={(newValue) => {
                          const updated = newValue || [];

                          setSelectedLabel(updated);
                          handleAddLabel(updated); // ← Pass updated list
                        }}
                      />
                    </Box>

                    <Text fontWeight="semibold">Parent</Text>
                    <CreatableSelect
                      isDisabled={![1, 2, 3].includes(roleId)}
                      placeholder="Select Parent"
                      isClearable
                      value={selectedparent}
                      onChange={(selected) => {
                        setSelectedParent(selected);
                        handleTaskUpdate(selected);
                      }}
                      options={epicList?.map((epic) => ({
                        value: epic.epic_id,
                        label: epic.epic_name,
                      }))}
                    />

                    <Text fontWeight="semibold">Due date</Text>
                    <Input
                      type="date"
                      size="sm"
                      value={dueDate || taskdata?.formatdue_date}
                      onChange={(e) => setDueDate(e.target.value)}
                      onBlur={handleTaskUpdate}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleTaskUpdate(); // ✅ Save on Enter
                          e.target.blur();
                        }
                      }}
                      isDisabled={![1, 2, 3].includes(roleId)}
                    />

                    <Text fontWeight="semibold">Start date</Text>
                    <Input
                      type="date"
                      size="sm"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      onBlur={handleTaskUpdate}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleTaskUpdate();
                          e.target.blur();
                        }
                      }}
                      isDisabled={![1, 2, 3].includes(roleId)}
                    />

                    <Text fontWeight="semibold">Sprint</Text>
                    <Text>
                      {/* {taskDetails?.task?.sprint_name || taskDetails?.sprint_name || 'SCRUM Sprint 1'} */}
                      <CreatableSelect
                        isDisabled={![1, 2, 3].includes(roleId)}
                        placeholder="Select or create sprint"
                        isClearable
                        value={
                          selectedSprint ||
                          sprintOptions?.find(
                            (s) => s.label === taskdata?.sprint_name,
                          ) ||
                          (taskdata?.sprint_name
                            ? {
                                label: taskdata.sprint_name,
                                value: taskdata.sprint_id,
                              }
                            : null)
                        }
                        options={sprintOptions}
                        onChange={(newValue) => {
                          setSelectedSprint(newValue);
                          handleTaskUpdate();
                        }}
                        formatCreateLabel={(inputValue) =>
                          `Create new sprint: "${inputValue}"`
                        }
                      />
                    </Text>

                    <Text fontWeight="semibold">Story points</Text>
                    <Input
                      size="sm"
                      placeholder="Add story points"
                      w="100%"
                      type="number"
                      value={storyPoints}
                      onChange={(e) => setStoryPoints(e.target.value)} // <-- update state
                      onBlur={debouncedUpdate}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleTaskUpdate();
                          e.target.blur();
                        }
                      }}
                      isDisabled={![1, 2, 3].includes(roleId)}
                    />

                    <Text fontWeight="semibold">Development</Text>
                    <VStack align="start" spacing={2}></VStack>

                    <Text fontWeight="semibold">Reporter</Text>
                    <HStack align="center" spacing={2}>
                      <Avatar
                        name={taskdata?.issue_created_by_name || 'Unknown'}
                        size="xs"
                      />
                      <Text fontSize="sm" lineHeight="1">
                        {taskdata?.issue_created_by_name || 'Unknown'}
                      </Text>
                    </HStack>
                  </Grid>

                  <div
                    style={{
                      padding: '12px 16px',
                      // border: '1px solid #e6e6e6',
                      borderRadius: 8,
                      // background: '#fff',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 10,
                    }}
                  >
                    <div
                      style={{ display: 'flex', alignItems: 'center', gap: 16 }}
                    >
                      <span style={{ width: 120, fontWeight: 300 }}>
                        Created at
                      </span>
                      <Text style={{ color: '#333' }}>
                        {taskdata?.created_at
                          ? dayjs(taskdata?.created_at).format(
                              'DD MMM YYYY, hh:mm A',
                            )
                          : 'Unknown'}
                      </Text>
                    </div>
                    <div
                      style={{ display: 'flex', alignItems: 'center', gap: 16 }}
                    >
                      <span style={{ width: 120, fontWeight: 300 }}>
                        Updated at
                      </span>
                      <Text style={{ color: '#333' }}>
                        {taskdata?.updated_at
                          ? dayjs(taskdata?.updated_at).format(
                              'DD MMM YYYY, hh:mm A',
                            )
                          : 'Unknown'}
                      </Text>
                    </div>
                  </div>
                </Box>
              </Flex>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
      {/* {subtaskmodal && selectedSubtask && (
        <SubTaskModal
          isOpen={subtaskmodal}
          subtaskdetails={selectedSubtask}
          onClose={handlesubtaskmodal}
          taskDetails={taskDetails}
          assigneeList={assigneeList}
        />
      )} */}

      <ShareWorkItemModal
        isOpen={isShareOpen}
        onClose={() => setIsShareOpen(false)}
        project_id={taskDetails.project_id || taskdata.project_id}
        issue_id={taskdata?.issue_id} //issue_id:435
        issue_type_id={taskdata?.issue_type_id} //issue_type_id:1
      />

      <Modal
        isOpen={epicModalOpen}
        onClose={() => setEpicModalOpen(false)}
        isCentered
      >
        <ModalOverlay />
        <ModalContent maxW="700px" minH="300px" mt="80px">
          {' '}
          {/* Increase width here */}
          <ModalHeader>Add Epic</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text mb={3}>
              Select a parent work item. Work items can only belong to one
              parent at a time.
            </Text>
            <Select
              placeholder="Select Parent"
              value={selectedEpic}
              onChange={(e) => setSelectedEpic(Number(e.target.value))} // force same type
              mt={3}
            >
              {epicList?.map((epic) => (
                <option key={epic.epic_id} value={epic.epic_id}>
                  {epic.epic_name}
                </option>
              ))}
            </Select>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={() => {
                handleTaskUpdate({ value: selectedEpic });
                setEpicModalOpen(false);
              }}
            >
              Add
            </Button>
            <Button variant="ghost" onClick={() => setEpicModalOpen(false)}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default TaskModal;
